<template>
    <ValidationObserver ref="obs" v-slot="{ invalid }" tag="form" class="form-thin" @submit.prevent="submit">
        <div class="mb-4">
            <ValidationProvider v-errors.api vid="enabled" tag="div" class="custom-control custom-switch mb-3 mb-xl-1">
                <input id="enabled" v-model="form.enabled" type="checkbox" class="custom-control-input">
                <label class="custom-control-label" for="enabled">Включить программу лояльности</label>
            </ValidationProvider>
        </div>

        <div class="mb-4">
            <small class="d-block text-muted mb-2">Тип скидки</small>

            <div class="custom-control custom-radio mb-1">
                <input id="type1" v-model="form.type" type="radio" name="type" :value="1" class="custom-control-input" :disabled="!form.enabled">
                <label class="custom-control-label" for="type1">Скидка в процентах</label>
            </div>
            <div class="custom-control custom-radio mb-1">
                <input id="type2" v-model="form.type" type="radio" name="type" :value="2" class="custom-control-input" :disabled="!form.enabled">
                <label class="custom-control-label" for="type2">Скидка в рублях</label>
            </div>
            <div class="custom-control custom-radio mb-1">
                <input id="type3" v-model="form.type" type="radio" name="type" :value="3" class="custom-control-input" :disabled="!form.enabled">
                <label class="custom-control-label" for="type3">Кэшбек в процентах</label>
            </div>
        </div>

        <div class="mb-4">
            <small class="d-block text-muted mb-2">
                {{ form.type === 3 ? 'Размер кешбека в процентах' : 'Размер скидки' }}
            </small>
            <ValidationProvider v-errors.api tag="div" vid="value" class="form-group flex-fill" rules="required">
                <input v-model="form.value" type="number" class="form-control" placeholder="Скидка" :disabled="!form.enabled">
            </ValidationProvider>
        </div>

        <div v-if="form.type === 1 || form.type === 2">
            <small class="d-block text-muted mb-2">Расписание</small>
            <small v-if="scheduleError" class="d-block text-danger mb-3">{{ scheduleError }}</small>

            <div class="d-flex justify-content-between mb-4 mx-4">
                <div>
                    <div v-for="item in schedule0" :key="item.time" class="flex-fill">
                        <ValidationProvider v-errors.api :vid="`schedule_${item.time}`" tag="div" class="custom-control custom-checkbox mb-3 mb-xl-1">
                            <input :id="`schedule_${item.time}`" v-model="item.value" type="checkbox" class="custom-control-input" :disabled="!form.enabled">
                            <label class="custom-control-label" :for="`schedule_${item.time}`">{{ item.time }}</label>
                        </ValidationProvider>
                    </div>
                </div>

                <div>
                    <div v-for="item in schedule1" :key="item.time" class="flex-fill">
                        <ValidationProvider v-errors.api :vid="`schedule_${item.time}`" tag="div" class="custom-control custom-checkbox mb-3 mb-xl-1">
                            <input :id="`schedule_${item.time}`" v-model="item.value" type="checkbox" class="custom-control-input" :disabled="!form.enabled">
                            <label class="custom-control-label" :for="`schedule_${item.time}`">{{ item.time }}</label>
                        </ValidationProvider>
                    </div>
                </div>

                <div>
                    <div v-for="item in schedule2" :key="item.time" class="flex-fill">
                        <ValidationProvider v-errors.api :vid="`schedule_${item.time}`" tag="div" class="custom-control custom-checkbox mb-3 mb-xl-1">
                            <input :id="`schedule_${item.time}`" v-model="item.value" type="checkbox" class="custom-control-input" :disabled="!form.enabled">
                            <label class="custom-control-label" :for="`schedule_${item.time}`">{{ item.time }}</label>
                        </ValidationProvider>
                    </div>
                </div>

                <div>
                    <div v-for="item in schedule3" :key="item.time" class="flex-fill">
                        <ValidationProvider v-errors.api :vid="`schedule_${item.time}`" tag="div" class="custom-control custom-checkbox mb-3 mb-xl-1">
                            <input :id="`schedule_${item.time}`" v-model="item.value" type="checkbox" class="custom-control-input" :disabled="!form.enabled">
                            <label class="custom-control-label" :for="`schedule_${item.time}`">{{ item.time }}</label>
                        </ValidationProvider>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="form.type === 3">
            <small class="d-block text-muted mb-2">Кэшбек в процентах не требует расписания, работает все время - 24/7.</small>
        </div>

        <div class="d-flex flex-column flex-sm-row justify-content-sm-between align-items-sm-center pt-3">
            <div>
                <button :disabled="invalid || pending" type="submit" class="btn btn-lg-192 btn-primary mr-sm-3 mb-3 mb-sm-0">Сохранить изменения</button>
                <!-- <button type="button" class="btn btn-lg-192 btn-outline-primary" @click="cancel">Отменить</button> -->
            </div>
        </div>
    </ValidationObserver>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { mixinApiErrors } from '@/validation'

const defaultSchedule = ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23'].map((hour) => (
    {
        time: `${hour}:00`,
        value: false
    }
))

function scheduleToObject(schedule) {
    const obj = {}

    schedule.forEach(item => {
        obj[item.time] = item.value
    })

    return obj
}

function scheduleFromObject(schedule) {
    const arr = []

    Object.keys(schedule).sort().forEach(key => {
        arr.push({
            time: key,
            value: schedule[key]
        })
    })

    return arr
}

export default {
    components: {
        ValidationProvider,
        ValidationObserver
    },

    props: {
        loyalty: {
            type: Object,
            default: _ => ({})
        },

        pending: {
            type: Boolean,
            default: false
        }
    },

    data() {
        const form = {
            enabled: this.loyalty.enabled || false,
            type: this.loyalty.type || 1,
            value: this.loyalty.value || null,
            schedule: []
        }

        const schedule = scheduleToObject(defaultSchedule);

        (this.loyalty.schedule || []).forEach((item) => {
            schedule[item.time] = item.value
        })

        form.schedule = scheduleFromObject(schedule)

        return {
            form,
            scheduleError: null
        }
    },

    computed: {
        schedule() {
            return this.form.schedule
        },

        schedule0() {
            return [this.schedule[0], this.schedule[1], this.schedule[2], this.schedule[3], this.schedule[4], this.schedule[5]]
        },

        schedule1() {
            return [this.schedule[6], this.schedule[7], this.schedule[8], this.schedule[9], this.schedule[10], this.schedule[11]]
        },

        schedule2() {
            return [this.schedule[12], this.schedule[13], this.schedule[14], this.schedule[15], this.schedule[16], this.schedule[17]]
        },

        schedule3() {
            return [this.schedule[18], this.schedule[19], this.schedule[20], this.schedule[21], this.schedule[22], this.schedule[23]]
        }
    },

    watch: {
        schedule: {
            deep: true,
            handler() {
                this.scheduleError = null
            }
        }
    },

    methods: {
        async submit() {
            const isValid = await this.$refs.obs.validate()

            if (isValid) {
                this.$emit('save', this.form)
            }
        },

        mixinApiErrors(errors) {
            if (errors.errors.schedule && errors.errors.schedule.length) {
                this.scheduleError = errors.errors.schedule.join(', ')
            }

            mixinApiErrors(this.$refs.obs, errors)
        }
    }
}
</script>
